import { render, staticRenderFns } from "./InformacionGeneralLab.vue?vue&type=template&id=3e0788da&scoped=true"
import script from "./InformacionGeneralLab.vue?vue&type=script&lang=js"
export * from "./InformacionGeneralLab.vue?vue&type=script&lang=js"
import style0 from "./InformacionGeneralLab.vue?vue&type=style&index=0&id=3e0788da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0788da",
  null
  
)

export default component.exports